// extracted by mini-css-extract-plugin
module.exports = {"datesWrapper":"_2_EcfCWMSg5F","weekdays":"_1UaKRBqaIBfp","scheduleDates":"_1BGolkEQhL_9","segments":"cdwk_7OnOrX_"};